import { withStyles } from '@material-ui/styles';
import { buttonGroupStyles } from '../material-styles';
import { ButtonGroup } from '@material-ui/core';

const ContainedButtons = withStyles(buttonGroupStyles)(ButtonGroup);

export default ContainedButtons;